export const  REGISTER_LOADING = "REGISTER_LOADING"
export const  REGISTER_SUCCESS = "REGISTER_SUCCESS"
export const  REGISTER_ERROR = "REGISTER_ERROR"

export const  LOGIN_LOADING = "LOGIN_LOADING"
export const  LOGIN_SUCCESS = "LOGIN_SUCCESS"
export const  LOGIN_ERROR = "LOGIN_ERROR"

export const  LOGOUT_SUCCESS = "LOGOUT_SUCCESS"

export const  USER_LOADING = "USER_LOADING"
export const  USER_LOADED = "USER_LOADED"
export const  AUTH_ERROR = "AUTH_ERROR"

export const  CONTACTS_LOADING = "CONTACTS_LOADING"
export const  CONTACTS_LOAD_SUCCESS = "CONTACTS_LOAD_SUCCESS"
export const  CONTACTS_LOAD_ERROR = "CONTACTS_LOAD_ERROR"

export const ADD_CONTACT_LOAD = "ADD_CONTACT_LOAD";
export const ADD_CONTACT_SUCCESS = "ADD_CONTACT_SUCCESS";
export const ADD_CONTACT_ERROR = "ADD_CONTACT_ERROR";
export const CLEAR_ADD_CONTACT = "CLEAR_ADD_CONTACT";